<template>
  <div class="cp-set-icons main">
    <div class="divider" />

    <div class="row">
      <p><i class="far fa-user-circle icon" />Browser Icon</p>
      <p class="favicon">
        <img :src="favicon" />
        <!-- <img :src="business.profile_pic_url" class="profile-pic-round" /> -->
      </p>
      <p class="value">
        The browser icon (favicon) appears in web browser tabs and should be
        32x32 pixels.
      </p>
      <div class="save-wrapper">
        <p class="button has-text-success" @click="setPic('favicon')">
          <span>Change</span>
        </p>
      </div>
    </div>

    <div class="divider" />

    <div class="row">
      <p><i class="far fa-user-circle icon" />Notification Icon</p>
      <p class="profile">
        <img :src="business.profile_pic_url" class="profile-pic-square" />
        <img :src="business.profile_pic_url" class="profile-pic-round" />
      </p>
      <p class="value">
        The notification icon appears in app push notifications.
      </p>
      <div class="save-wrapper">
        <p class="button has-text-success" @click="setPic('notification')">
          <span>Change</span>
        </p>
      </div>
    </div>

    <input
      type="file"
      ref="file"
      style="display: none"
      accept="image/*"
      @change="setPicAWS($event)"
    />
  </div>
</template>


<script>
import imageCompression from "browser-image-compression";

export default {
  name: "CPSetIcons",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      imageType: "icon", // favicon, notification etc
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    favicon() {
      var fallback = "https://bulma.io/images/placeholders/32x32.png";
      return this.business.data.favicon_pic_url || fallback;
    },
  },
  methods: {
    setPic(type) {
      this.imageType = type;
      this.infoToast("Coming Soon...");
      //   this.$refs.file.click();
    },
    savePicURL(picURL) {
      var data = {};
      data[`${this.imageType}_pic_url`] = picURL;
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: data,
        })
        .then((res) => {
          this.business.data = res.data.data;
          this.successToast("Success!");
        })
        .catch((err) => this.apiError(err));
    },
    // should be smaller for icons, maybe 32x or 64x pixels
    setPicAWS(e) {
      if (!e.target.files) return;
      if (!e.target.files.length) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: this.$shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: this.business.id,
                imageType: this.imageType,
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  var newPicURL = res.data.compressed_image_url;
                  this.savePicURL(newPicURL);
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.profile {
  margin-left: 32px;
  margin-top: 10px;
}
.profile img {
  display: inline-block;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  height: 90px;
  width: 90px;
}
.profile-pic-round {
  border-radius: 100px;
  object-fit: cover;
}
.profile-pic-square {
  border-radius: 2px;
  margin-right: 20px;
}
.favicon img {
  display: inline-block;
  /* box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14); */
  height: 32px;
  width: 32px;
  margin-left: 32px;
  margin-top: 6px;
}
</style>
